import { useState } from "react"
import { faClose, faKey, faLock } from "@fortawesome/free-solid-svg-icons"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import { SIZE } from "../../../configuration/Sizes"
import THEME from "../../../configuration/Theme"
import { AdminEmployee } from "../../../Objects/AdminEmployee/AdminEmployee"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { useTranslation } from "react-i18next"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import InputField from "../../../components/InputField/InputField"
import GetSpace from "../../../utils/space"
import { useAdminEmployeeChangePassword } from "../../../hooks/AdminEmployee/useAdminEmployeeChangePassword"
import { useMessage } from "../../../context/useMessageContext"

interface AdminChangePasswordPopupProps {
  employee: AdminEmployee
  onClose: () => void
}

export const AdminChangePasswordPopup: React.FC<AdminChangePasswordPopupProps> = ({ employee, onClose }) => {
  const { t } = useTranslation("adminEmployee")

  const [newPassword, setNewPassword] = useState("")

  const { setMessage } = useMessage()

  const { handleChangePassword } = useAdminEmployeeChangePassword()

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()

    handleChangePassword(employee.adminEmployeeId, newPassword, () => {
      onClose()

      setMessage(t("label_title_change_password"), t("label_description_change_password_success"))
    })
  }

  return (
    <div className={defaultStyle.overlay}>
      <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
        <div className={defaultStyle.alert1}>
          <TitlePageResponsiveIconSmall
            title={t("label_title_change_password")}
            icon={faKey}
            children={
              <ButtonIcon
                sizeNumber={SIZE.buttonCloseIconSize}
                bgColor={THEME.colors.buttonBGCloseColor}
                iconColor={THEME.colors.buttonFGCloseColor}
                icon={faClose}
                onClick={onClose}
                size="small"
                descriptionKey="interactionDescriptions:pages.adminDashboard.adminStaff.adminChangePasswordPopup.button.close"
              />
            }
          />

          <GetSpace top={5} />

          <form onSubmit={handleSubmit}>
            <div className="p-1">
              <InputField
                type="password"
                placeholder={t("label_new_password_place_holder")}
                onInvalidMessage={t("label_new_password_onInvalidMessage")}
                icon={faLock}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                descriptionKey="interactionDescriptions:pages.adminDashboard.adminStaff.adminChangePasswordPopup.input.newPassword"
              />
            </div>

            <div className={defaultStyle.divisionBar}></div>

            <div className="flex justify-end items-center w-full gap-2">
              <Button
                label={t("buttons:button_save")}
                typeButton="submit"
                type="primary"
                size="medium"
                bgColor={THEME.colors.buttonBGSaveColor}
                descriptionKey="interactionDescriptions:pages.adminDashboard.adminStaff.adminChangePasswordPopup.button.save"
              />
            </div>
          </form>
        </div>
      </Animate>
    </div>
  )
}
